import React, { useEffect } from 'react';

/**
 * Utility function to scroll to the top of the page
 */
export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

/**
 * Hook to scroll to top on component mount
 */
export const useScrollToTop = () => {
  useEffect(() => {
    scrollToTop();
  }, []);
};

/**
 * Higher-order component to wrap pages that should scroll to top on mount
 */
export const withScrollToTop = <P extends object>(Wrapped: React.ComponentType<P>) => {
  return (props: P) => {
    useScrollToTop();
    return React.createElement(Wrapped, { ...(props as P) });
  };
};
